import { Component, OnInit } from '@angular/core';
// import { routerTransition } from '../../router.animations';
@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
  // animations: [routerTransition()]
})
export class AboutUsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/bs_work/toMigrate_litePortal/src/app/main/main-portal/about-us/about-us.component.ts